import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.loader),callback:function ($$v) {_vm.loader=$$v},expression:"loader"}},[_c(VCard,[_c(VCardTitle,{attrs:{"primary-title":""}},[_c('span',{staticClass:"text-body-1"},[_vm._v("Lo sentimos, pero no tienes internet en estos momentos")])]),_c(VCardTitle,{attrs:{"primary-title":""}},[_c('span',{staticClass:"text-body-1"},[_vm._v("Activa tu internet para poder continuar")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }